// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../common/Components/IconV5.bs.js");
let Container = require("../common/Components/Container.bs.js");
let Next__Image = require("../../reason/next/Next__Image.bs.js");
let PropertyPrice = require("../common/Components/PropertyPrice.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RentalPropertyAttributes = require("../common/Components/RentalPropertyAttributes.bs.js");
let ForSalePropertyAttributes = require("../common/Components/ForSalePropertyAttributes.bs.js");
let UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
let WithdrawnSharedPropertyLocation = require("./WithdrawnSharedPropertyLocation.bs.js");
let WithdrawnSharedPropertyV5_property_graphql = require("../../__generated__/WithdrawnSharedPropertyV5_property_graphql.bs.js");
let WithdrawnSharedPropertyV5_sharedProperty_graphql = require("../../__generated__/WithdrawnSharedPropertyV5_sharedProperty_graphql.bs.js");
let WithdrawnSharedPropertyV5_propertyAttributes_graphql = require("../../__generated__/WithdrawnSharedPropertyV5_propertyAttributes_graphql.bs.js");

let convertFragment = WithdrawnSharedPropertyV5_propertyAttributes_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, WithdrawnSharedPropertyV5_propertyAttributes_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(WithdrawnSharedPropertyV5_propertyAttributes_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, WithdrawnSharedPropertyV5_propertyAttributes_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(WithdrawnSharedPropertyV5_propertyAttributes_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function WithdrawnSharedPropertyV5$PropertyAttributes(props) {
  let property = RescriptRelay_Fragment.useFragment(WithdrawnSharedPropertyV5_propertyAttributes_graphql.node, convertFragment, props.property);
  let tmp;
  switch (property.__typename) {
    case "ForSalePropertyV5" :
      tmp = JsxRuntime.jsx(ForSalePropertyAttributes.make, {
        property: property.fragmentRefs
      });
      break;
    case "RentalPropertyV5" :
      tmp = JsxRuntime.jsx(RentalPropertyAttributes.make, {
        property: property.fragmentRefs
      });
      break;
    case "__unselected" :
      tmp = UnselectedUnionMemberError.raise(`Unexpected unselected union member: ` + property._0);
      break;
  }
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: "flex flex-col gap-2"
  });
}

let PropertyAttributes = {
  Fragment: Fragment,
  make: WithdrawnSharedPropertyV5$PropertyAttributes
};

let convertFragment$1 = WithdrawnSharedPropertyV5_property_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, WithdrawnSharedPropertyV5_property_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(WithdrawnSharedPropertyV5_property_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, WithdrawnSharedPropertyV5_property_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(WithdrawnSharedPropertyV5_property_graphql.node, convertFragment$1, fRef);
}

let PropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

let convertFragment$2 = WithdrawnSharedPropertyV5_sharedProperty_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, WithdrawnSharedPropertyV5_sharedProperty_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(WithdrawnSharedPropertyV5_sharedProperty_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, WithdrawnSharedPropertyV5_sharedProperty_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(WithdrawnSharedPropertyV5_sharedProperty_graphql.node, convertFragment$2, fRef);
}

let SharedPropertyFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function WithdrawnSharedPropertyV5$SlimCard(props) {
  let property = RescriptRelay_Fragment.useFragment(WithdrawnSharedPropertyV5_property_graphql.node, convertFragment$1, props.property);
  let sharedProperty = RescriptRelay_Fragment.useFragment(WithdrawnSharedPropertyV5_sharedProperty_graphql.node, convertFragment$2, props.sharedProperty);
  let imageSrc = Stdlib_Option.flatMap(Stdlib_Option.flatMap(Stdlib_Option.map(property.firstImage, images => images.edges), edges => edges[0]), edge => Stdlib_Option.map(edge, e => e.node.url));
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: imageSrc !== undefined ? JsxRuntime.jsx(Next__Image.make, {
            src: imageSrc,
            fill: true,
            unoptimized: true,
            alt: "",
            className: "object-cover"
          }) : JsxRuntime.jsx(IconV5.make, {
            icon: "home",
            size: 42
          }),
        className: "relative flex-shrink-0 w-full h-32 bg-gray-200 flex items-center justify-center md:w-44 md:h-auto"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx(WithdrawnSharedPropertyLocation.make, {
            sharedProperty: sharedProperty.fragmentRefs
          }),
          JsxRuntime.jsx(PropertyPrice.make, {
            property: property.fragmentRefs,
            size: "medium"
          }),
          JsxRuntime.jsx(WithdrawnSharedPropertyV5$PropertyAttributes, {
            property: property.fragmentRefs
          })
        ],
        className: "flex-grow flex flex-col p-4 gap-2"
      })
    ],
    className: "w-full flex flex-col md:flex-row border rounded border-gray-200 bg-white"
  });
}

let SlimCard = {
  make: WithdrawnSharedPropertyV5$SlimCard
};

function WithdrawnSharedPropertyV5(props) {
  return JsxRuntime.jsx(Container.make, {
    children: JsxRuntime.jsx("div", {
      children: JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(IconV5.make, {
              icon: "attention-alt",
              size: 60,
              className: "text-tan-biscay h-15 w-15"
            }),
            className: "pl-4 pr-8"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("div", {
                    children: `This property is no longer available`,
                    className: "text-3xl text-gray-700"
                  }),
                  JsxRuntime.jsx("div", {
                    children: "This property has been withdrawn from TAN. For more information, please contact your agent.",
                    className: "mt-2 text-base"
                  })
                ],
                className: "mb-6"
              }),
              JsxRuntime.jsx(WithdrawnSharedPropertyV5$SlimCard, {
                property: props.property,
                sharedProperty: props.sharedProperty
              })
            ]
          })
        ],
        className: "flex flex-row"
      }),
      className: "bg-white p-5 border rounded"
    })
  });
}

let make = WithdrawnSharedPropertyV5;

exports.PropertyAttributes = PropertyAttributes;
exports.PropertyFragment = PropertyFragment;
exports.SharedPropertyFragment = SharedPropertyFragment;
exports.SlimCard = SlimCard;
exports.make = make;
/* IconV5 Not a pure module */
